module.exports = __webpack_public_path__ + "img/gys_11@2x.bf65c75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_11@2x.png
// module id = lH3J
// module chunks = 0